import { gsap } from 'gsap/gsap-core';

export const init = (): void => {
    const stacks = document.querySelectorAll<HTMLElement>('[data-stack]');

    stacks.forEach((item) => {
        const children = Array.from(item.children) as HTMLElement[];

        if (children.length === 0) return;

        const repeat = item.dataset.repeat !== 'false';

        gsap.set(children, {
            opacity: 0.08,
            x: 30,
            transition: 'none',
        });

        gsap.to(children, {
            x: 0,
            opacity: 1,
            duration: 1.4,
            ease: 'expo.out',
            stagger: 0.1,
            scrollTrigger: {
                trigger: item,
                start: 'top 70%',
                end: 'top 40%',
                once: !repeat,
            },
        });
    });
};
